module.exports = __webpack_public_path__ + "static/media/sort-amount-down.ddd0d12a.svg";